const MAX_ACTION_BUCKET_SIZE = 40;

export default (actionBucket) => () => (next) => (action) => {
  actionBucket.push(action);
  if (actionBucket.length > MAX_ACTION_BUCKET_SIZE) {
    actionBucket.splice(1);
  }
  return next(action);
};
